export default function PartnersSection() {
  const partners = [
    { name: 'Aetna', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/1.png' },
    { name: 'Cigna', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/2.png' },
    { name: 'United Healthcare', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/3.png' },
    { name: 'Blue Cross', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/4.png' },
    { name: 'Humana', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/5.png' },
    { name: 'Partner 6', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/6.png' },
    { name: 'Partner 7', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/7.png' },
    { name: 'Partner 8', logo: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/10/8.png' }
  ];

  return (
    <section className="py-20 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Trusted <span className="text-teal-600">Partners</span>
          </h2>
          <p className="text-slate-600">Working with industry-leading insurance providers</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-8 items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 bg-slate-50 rounded-xl hover:bg-white hover:shadow-md transition-all duration-300 border border-slate-100"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
